import { useDispatch } from "react-redux";
import { setUser } from "../../redux/slice/user";
import {
  setFormType,
  setFormStep,
  setFormUser,
  setFormDetail,
} from "../../redux/slice/form";

const useLocalStorageToRedux = () => {
  const dispatch = useDispatch();

  return () => {
    let localData = [
      {
        type: "json",
        name: "user",
        action: (e) => setUser(e),
      },
      {
        type: "string",
        name: "formType",
        action: (e) => setFormType(e),
      },
      {
        type: "string",
        name: "formStep",
        action: (e) => setFormStep(e),
      },
      {
        type: "json",
        name: "formUser",
        action: (e) => setFormUser(e),
      },
      {
        type: "json",
        name: "formDetail",
        action: (e) => setFormDetail(e),
      },
    ];

    localData.forEach((item) => {
      let local = localStorage.getItem(item.name);
      if (local) {
        local = item.type === "json" ? JSON.parse(local) : local;
        dispatch(item.action(local));
      }
    });
  };
};

export default useLocalStorageToRedux;
